import { render, staticRenderFns } from "./interviews_table.vue?vue&type=template&id=063eebf2&scoped=true&lang=pug&"
import script from "./interviews_table.vue?vue&type=script&lang=coffee&"
export * from "./interviews_table.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063eebf2",
  null
  
)

export default component.exports